// src/guards/ProtectedRoute.js
// This is the security guard for all protected pages.
// If no token found in localStorage → redirect to login page.
// If allowedRoles given and user's roleId not in it → redirect to their correct home.

import { Navigate, useLocation } from "react-router-dom";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  const allowedPages = JSON.parse(localStorage.getItem("allowedPages") || "[]");
  const roleId = parseInt(localStorage.getItem("roleId"));
  const location = useLocation();

  if (!token) return <Navigate to="/" replace />;

  // Explicit exception to the "*" wildcard: Admin/SuperAdmin can access
  // everything except "My Reports", which is Team Lead/HR-only.
  if ([1, 2].includes(roleId) && location.pathname.startsWith("/reporting/myreports")) {
    return <Navigate to="/reporting/Dashboard" replace />;
  }

  if (allowedPages.includes("*")) return children;

  const canAccess = allowedPages.some(p => location.pathname.startsWith(p));
  if (!canAccess) return <Navigate to="/reporting/Dashboard" replace />;

  return children;
}

export default ProtectedRoute;